import { render, staticRenderFns } from "./Atlases4Admin.vue?vue&type=template&id=9ca4c9c8&scoped=true&"
import script from "./Atlases4Admin.vue?vue&type=script&lang=js&"
export * from "./Atlases4Admin.vue?vue&type=script&lang=js&"
import style0 from "./Atlases4Admin.vue?vue&type=style&index=0&id=9ca4c9c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca4c9c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDataTable,VIcon,VProgressCircular})
